"use client";

import { Icon, TextInput, TextInputProps } from "@zapier/design-system";
import { useEffect, useState } from "react";

export type SearchInputProps = Omit<TextInputProps, "onChange"> & {
  handleChange: (value: string) => void;
  debounceDuration?: number;
};

export default function SearchInput({
  handleChange,
  value = "",
  debounceDuration = 300,
  renderIconBefore = () => <Icon name="navSearch" size={30} />,
  ...textInputProps
}: SearchInputProps) {
  const [textValue, setTextValue] = useState(value);

  useEffect(() => {
    // NOTE: this handles cases where new value is passed (as is the case when the input is controlled outside of this component, like when its cleared)
    setTextValue(value);
  }, [value]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      handleChange(textValue);
    }, debounceDuration);
    return () => {
      clearTimeout(debounceTimer);
    };
  }, [handleChange, textValue]);

  return (
    <TextInput
      {...textInputProps}
      value={textValue}
      renderIconBefore={renderIconBefore}
      onChange={(e) => setTextValue(e.target.value)}
    />
  );
}
